// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__236kj","row":"ProcedureTreatmentSummary_row__23J_W"};